import "./styles/preview-step.css";

export default function GiftPreview({ gift, onEdit, onCheckout }) {
  const planLabel = gift.planId?.replace("couples_", "")?.toUpperCase() || "—";
  const venueText = gift.venueName
    ? `${gift.venueName}${gift.venueStatus === "missing" ? "" : ""}`
    : "Not specified";

  return (
    <section className="gift-preview fade-in">
      <h2>Review & Confirm</h2>

      <div className="plan-pill">{planLabel}</div>

      <div className="summary-grid">
        <div className="summary-card">
          <h3>Plan</h3>
          <p>{planLabel}</p>
        </div>

        <div className="summary-card">
          <h3>Venue</h3>
          <p>
            {venueText}
            {gift.venueStatus === "missing" && (
              <span className="badge">adding soon</span>
            )}
          </p>
        </div>

        <div className="summary-card">
          <h3>Gifter</h3>
          <p>
            {gift.gifterName} — {gift.gifterEmail}
          </p>
        </div>

        <div className="summary-card">
          <h3>Recipient</h3>
          <p>
            {gift.recipientName} — {gift.recipientEmail}
          </p>
        </div>

        {gift.note && (
          <div className="summary-card message-card">
            <h3>Personal Message</h3>
            <p>{gift.note}</p>
          </div>
        )}
      </div>

      <div className="actions">
        <button className="secondary-btn" onClick={onEdit}>
          Edit
        </button>
        <button className="primary-btn" onClick={onCheckout}>
          Confirm & Checkout →
        </button>
      </div>
    </section>
  );
}
